import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import styled from 'styled-components';

export interface ICardFooterProps {
  $isDividerVisible?: boolean;
}

export const StyledCardFooter = styled.div<ICardFooterProps>`
  background-color: ${props => props.theme.colors.surface.primary};
  width: 100%;
  border-radius: 0 0 12px 12px;

  padding: 16px 16px 24px 16px;
  ${MediaQuery.Tablet} {
    padding: 16px 24px 24px;
  }

  ${({ $isDividerVisible = true, theme }) =>
    $isDividerVisible
      ? `border-top: 1px solid ${theme.colors.general.border};`
      : ''}
`;

export default StyledCardFooter;
